import PostsAdapter from './base';

export default class Post extends PostsAdapter {
  modelNamePlural = 'posts';
}
